import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import React, { FC, useEffect, useState } from 'react';

import { SavedKind } from '../../model/store';

interface SaveCreativeModalProps {
  isOpen: boolean;
  kind: SavedKind;
  defaultName: string;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
}

const COPY: Record<SavedKind, { title: string; hint: string; confirm: string }> = {
  creative: {
    title: 'Zapisz kreację',
    hint: 'Kreacja trafia do wspólnej biblioteki generatora. Wrócisz do niej z zakładki Zapisane.',
    confirm: 'Zapisz kreację',
  },
  template: {
    title: 'Zapisz jako szablon',
    hint: 'Szablon pojawi się na liście szablonów. Użyty na innym formacie przeskaluje się proporcjonalnie.',
    confirm: 'Zapisz szablon',
  },
};

export const SaveCreativeModal: FC<SaveCreativeModalProps> = ({
  isOpen,
  kind,
  defaultName,
  isSaving,
  onClose,
  onConfirm,
}) => {
  const [name, setName] = useState(defaultName);
  const copy = COPY[kind];

  useEffect(() => {
    if (isOpen) setName(defaultName);
  }, [defaultName, isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" radius="sm">
      <ModalContent>
        <ModalHeader>{copy.title}</ModalHeader>
        <ModalBody>
          <Input
            size="sm"
            radius="sm"
            autoFocus
            label="Nazwa"
            labelPlacement="outside"
            value={name}
            maxLength={120}
            onValueChange={setName}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && name.trim()) onConfirm(name.trim());
            }}
          />
          <p className="text-xs text-gray-500 leading-relaxed">{copy.hint}</p>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" radius="sm" variant="light" onPress={onClose}>
            Anuluj
          </Button>
          <Button
            size="sm"
            radius="sm"
            className="bg-black text-white"
            isLoading={isSaving}
            isDisabled={!name.trim()}
            onPress={() => onConfirm(name.trim())}
          >
            {copy.confirm}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
